<template>
  <div class="w-100 row">
    <div class="col-12 col-md-6">
      <h3 class="mb-5">{{ title1 }}</h3>
      <div class="mb-10 draggable-zone draggable_class" ref="container1">
        <slot name="container1" />
      </div>
    </div>
    <div class="col-12 col-md-6">
      <h3 class="mb-5">{{ title2 }}</h3>
      <div class="mb-10 draggable-zone draggable_class" ref="container2">
        <slot name="container2" />
      </div>
    </div>
  </div>
</template>

<script setup>
import { defineProps, defineEmits, onMounted, nextTick, ref } from "vue";
import Sortable from "sortablejs";

const emits = defineEmits(["change", "statusChange"]);

const props = defineProps({
  title1: {
    type: String,
    default: "",
  },
  title2: {
    type: String,
    default: "",
  },
});

const container1 = ref(null);
const container2 = ref(null);

function InitDraggable() {
  if (!container1.value || !container2.value) {
    return false;
  }

  const sortable1 = new Sortable(container1.value, {
    group: "shared",
    draggable: ".draggable",
    handle: ".draggable-handle",
    animation: 150,
    onEnd: (event) => {
      let id = event.item.getAttribute("data-id");
      if (event.from !== event.to) {
        emits("statusChange", id);
      }
    },
  });

  const sortable2 = new Sortable(container2.value, {
    group: "shared",
    draggable: ".draggable",
    handle: ".draggable-handle",
    animation: 150,
    onEnd: (event) => {
      let id = event.item.getAttribute("data-id");
      let newIndex = event.newIndex;
      emits("change", { id, newIndex });
      if (event.from !== event.to) {
        emits("statusChange", id);
      }
    },
  });
}

onMounted(() => {
  nextTick(() => {
    InitDraggable();
  });
});
</script>

<style scoped>
.draggable_class {
  background-color: rgba(0, 114, 206, 0.05);
  min-height: 200px;
  height: auto;
  border-radius: 8px;
  padding: 5px;
}
</style>
